export const getErrorMessage = (errorMessage: string) => {
    if (
        errorMessage.includes("auth/user-not-found") ||
        errorMessage.includes("auth/wrong-password")
    ) {
        return "El usuario o la contraseña no son correctos. Verifica los datos e intenta de nuevo";
    }
    if (errorMessage.includes("auth/too-many-requests")) {
        return "Has tenido muchos intentos fallidos. Intentalo de nuevo más tarde.";
    }
    if (errorMessage.includes("auth/google-account-not-registered")) {
        return "No encontramos una cuenta Maifud asociada a ese acceso de Google. Si ya tienes cuenta, entra con correo y contraseña.";
    }
    if (
        errorMessage.includes("auth/account-exists-with-different-credential")
    ) {
        return "Este correo ya existe con otro método de acceso. Entra con correo y contraseña para mantener tu cuenta actual.";
    }
    if (
        errorMessage.includes("auth/popup-closed-by-user") ||
        errorMessage.includes("auth/cancelled-popup-request")
    ) {
        return "El acceso con Google fue cancelado. Intenta de nuevo si quieres continuar con Google.";
    }
    if (errorMessage.includes("auth/popup-blocked")) {
        return "El navegador bloqueó la ventana de Google. Permite popups para Maifud e intenta nuevamente.";
    }
    if (errorMessage.includes("auth/operation-not-allowed")) {
        return "El acceso con Google todavía no está habilitado en Firebase.";
    }
    return errorMessage;
};
